import apis from '@api/api';
import type { Plugin } from 'grapesjs';
import { QueryClient } from '@tanstack/react-query';
import { USER_API_BASE_URL } from '@api/constant';

const queryClient = new QueryClient();

const SmartSaasLinksPlugin: Plugin = async (editor, productList, opts = {}) => {
	editor.BlockManager.add('smartsaas-link', {
		label: 'SmartSaaS Link',
		category: 'SmartSaaS',
		content: {
			type: 'smartsaas-link',
		},
	});
};

const SmartSaasPlugin: Plugin = async (editor, productList, opts = {}) => {
	// Fetch or get the productServiceList using queryClient
	let productServiceList = await queryClient.fetchQuery<any[]>({
		queryKey: ['productServiceList'],
		queryFn: async () => {
			const data = await apis.getProductServiceList();
			return data;
		},
	});

	// Default options for the plugin
	const defaultOpts = {};
	const options = { ...defaultOpts, ...opts };

	// Add dynamic buttons based on productServiceList
	if (productServiceList && productServiceList.length > 0) {
		productServiceList.forEach((product, index) => {
			const productId = product._id;
			const productName =
				product.data.product_name ||
				product.data.name ||
				`Product ${index + 1}`;

			// Add a custom button block
			editor.BlockManager.add(`smartsaas-section-${productId}`, {
				label: productName,
				category: 'Products',
				media: `<img src="${product.dataImages?.[0] || ''}" style="width: 100%; height: auto; max-height: 60px; object-fit: contain;">`,
				content: {
					type: 'smartsaas-section',
					attributes: {
						productId,
						id: `smartsaas-section-${productId}`,
					}, // Unique ID
					content: `<button class="smartsaas-button">${productName}</button>`,
				},
			});
		});
	}

	// Monitor for components being added to the canvas
	editor.on('component:add', async (model) => {
		if (model.get('type') === 'smartsaas-section') {
			const productId = model.getAttributes().productId;

			// Show loading placeholder
			model.components(`
            <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100px;">
                <h5>Loading...</h5>
                <div style="width: 80%; height: 8px; background: #eee; border-radius: 4px; margin-top: 12px; overflow: hidden;">
                    <div class="progress-bar" style="width: 0%; height: 100%; background: #007bff; transition: width 0.8s;"></div>
                </div>
            </div>
        `);

			setTimeout(() => {
				const el = model.view?.el?.querySelector(
					'.progress-bar'
				) as HTMLElement;
				if (el) el.style.width = '80%';
			}, 300);

			try {
				const previousHtml = model.get('content') || '';
				const response = await apis.buildProductContent(
					productId,
					previousHtml
				);
				replaceProductSection(model, response.html);
			} catch (error) {
				console.error('Error fetching dynamic content:', error);
				replaceProductSection(
					model,
					'<div>Error loading content</div>'
				);
			}
		}
	});
};

function replaceProductSection(model, newHtml) {
	    let cleanHtml = newHtml.replace(/`/g, '').replace(/\\/g, '');
	// Add max-height to all images (preserve existing styles if any)
	cleanHtml = cleanHtml.replace(/<img([^>]*)>/gi, (match, attrs) => {
		if (/style\s*=/.test(attrs)) {
			return `<img${attrs.replace(
				/style\s*=\s*(['"])([^'"]*)\1/,
				(m, quote, s) =>
					`style=${quote}${s}; max-height:300px; height:auto; width:auto; object-fit:contain; position:static;${quote}`
			)}>`;
		}
		return `<img${attrs} style="max-height:300px; height:auto; width:auto; object-fit:contain; position:static;">`;
	});
	model.components('');
	model.components(cleanHtml);
}

export default SmartSaasPlugin as Plugin;
